import { Routes } from '@angular/router';
import { authGuardFn } from './auth.guard';
import { ScreenContainer } from './components/core/screen-container/screen-container';
import { BusinessPartners } from './components/business-partners/business-partners';
import { Users } from './components/users/users';
import { Providers } from './components/providers/providers';
import { Carriers } from './components/carriers/carriers';
import { Drivers } from './components/drivers/drivers';
import { HelpMenu } from './components/help-menu/help-menu';
import { Metrics } from './components/metrics/metrics';

export const routes: Routes = [
  {
    path: '',
    component: ScreenContainer,
    canActivate: [authGuardFn],
    children: [
      { path: '', redirectTo: 'help', pathMatch: 'full' },
      { path: 'business-partners', component: BusinessPartners },
      { path: 'users', component: Users },
      { path: 'providers', component: Providers },
      { path: 'carriers', component: Carriers },
      { path: 'drivers', component: Drivers },
      { path: 'metrics', component: Metrics },
      { path: 'help', component: HelpMenu }
    ]
  }
];
